export const SEO_SNIPPET = 'pr_seo_snippet';
export const REVIEW_DISPLAY = 'pr-review-display';
export const QUESTION_DISPLAY = 'pr-questiondisplay';
export const SNAPSHOT_TYPE = 'SIMPLE';
export const enum PAGINATION_TYPE {
    DEFAULT = 'DEFAULT',
    VERTICAL = 'VERTICAL'
}
export const AVERAGE_RATING = 'averageRating';
export const POWER_REVIEWS_SCRIPT = '//ui.powerreviews.com/stable/4.0/ui.js';
